import React, { Component } from "react";

import Logout from "./Logout";
import Meta from "../../helpers/meta";
import { Navigate } from "react-router-dom";
import UserInfo from "./UserInfo";
import UserMenu from "./UserMenu";
import { connect } from "react-redux";
import { getPages } from "../../../services/pages/actions";
import { getSingleLanguageData, getAllLanguages } from "../../../services/languages/actions";
import { updateUserInfo } from "../../../services/user/actions";

class Account extends Component {
	state = {
		avatarPopup: false,
	};
	hasFetchedUser = false;
	loadedLanguageId = null;

	componentDidMount() {
		const { user } = this.props;
		if (!user?.success) return;
		if (this.hasFetchedUser) return;

		this.hasFetchedUser = true;

		if (localStorage.getItem("storeColor")) {
			this.props.getPages();
			this.updateUserInfo();
		}
	}

	updateUserInfo = () => {
		if (this.userInfoFetched) return;
		this.userInfoFetched = true;

		const { user } = this.props;

		// this.props
		// 	.updateUserInfo(user.data.id, user.data.auth_token)
		// 	.finally(() => {
		// 	this.setState({ avatarPopup: false });
		// 	});
	};

	componentDidUpdate(prevProps) {
		const { languages, language } = this.props;

		if (!languages || !languages.length) return;

		const storedLang = localStorage.getItem("userPreferedLanguage");

		const targetLangId = storedLang
			? Number(storedLang)
			: languages.find((l) => l.is_default === 1)?.id;

		if (!targetLangId) return;

		// 🔑 HARD STOP: already loaded
		if (this.loadedLanguageId === targetLangId) return;

		// 🔑 HARD STOP: redux already has it
		if (language?.id === targetLangId) {
			this.loadedLanguageId = targetLangId;
			return;
		}

		this.loadedLanguageId = targetLangId;
		this.props.getSingleLanguageData(targetLangId);
	}


	handleOnChange = (event) => {
		// console.log(event.target.value);
		this.props.getSingleLanguageData(event.target.value);
		localStorage.setItem("userPreferedLanguage", event.target.value);
		var dir = event.target.value == 2 ? "rtl" : "ltr";
		document.dir = dir;
		document.lang = dir == "rtl" ? "he" : "en";
	
		if (window.frameElement) {
			window.frameElement.ownerDocument.documentElement.dir = dir;
		}
		if (window.parent) {
			window.parent.document.dir = dir;
			window.parent.document.lang = document.lang;
		}
	};

	render() {
		if (window.innerWidth > 768) {
			return <Navigate to="/" />;
		}
		if (localStorage.getItem("storeColor") === null) {
			return <Navigate to={"/"} />;
		}
		const { user, pages } = this.props;

		if (!user.success) {
			return (
				//Navigate to login page if not loggedin
				<Navigate to={"/login"} />
			);
		}
		// const languages = JSON.parse(localStorage.getItem("state")).languages;
		// console.log(languages);
		const languages = this.props.languages;

		return (
			<React.Fragment>
				<Meta
					seotitle={localStorage.getItem("footerAccount")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>
				<UserInfo
					user_info={user.data}
					updateUserInfo={this.updateUserInfo}
					avatarPopup={this.state.avatarPopup}
				/>

				<UserMenu pages={pages} />

				<Logout />

				{languages && languages.length > 1 && (
					<div className="mt-4 d-flex align-items-center justify-content-center mb-100">
						<div className="mr-2">{localStorage.getItem("changeLanguageText")}</div>
						<select
							onChange={this.handleOnChange}
							defaultValue={
								localStorage.getItem("userPreferedLanguage")
									? localStorage.getItem("userPreferedLanguage")
									: languages.filter((lang) => lang.is_default === 1)[0].id
							}
							className="form-control language-select"
						>
							{languages.map((language) => (
								<option value={language.id} key={language.id}>
									{language.language_name}
								</option>
							))}
						</select>
					</div>
				)}
				<div className="mb-100" />
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	user: state.user.user,
	pages: state.pages.pages,
	languages: state.languages.languages,
	language: state.languages.language,
});

export default (connect(
	mapStateToProps,
	{ getPages, getSingleLanguageData, getAllLanguages, updateUserInfo }
)(Account));
